import { useEffect } from 'react';

// Simple SEO helper: updates document title and meta tags on page load
// Usage: <SEO title="Page Title" description="Desc" url="/path" image="/img.png" />
export default function SEO({ title, description, url, image }) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    // Description
    updateMetaTag('description', description);

    // Open Graph
    updateMetaTag('property', 'og:title', title);
    updateMetaTag('property', 'og:description', description);
    updateMetaTag('property', 'og:url', url || '/');
    updateMetaTag('property', 'og:image', image || '/favicon.png');

    // Twitter
    updateMetaTag('name', 'twitter:title', title);
    updateMetaTag('name', 'twitter:description', description);
    updateMetaTag('name', 'twitter:image', image || '/favicon.png');
  }, [title, description, url, image]);

  // Helper to create or update a meta tag
  function updateMetaTag(attrName, attrValue, content) {
    if (!content) return;
    // Try to find existing tag by name or property
    const selector = attrName === 'property' ? `meta[property='${attrValue}']` : `meta[name='${attrValue}']`;
    let tag = document.querySelector(selector);
    if (!tag) {
      tag = document.createElement('meta');
      if (attrName === 'property') tag.setAttribute('property', attrValue);
      else tag.setAttribute('name', attrValue);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  }

  return null;
}
